import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useLiveData } from "@/context/LiveDataContext";
import DroneDetailPanel from "@/components/DroneDetailPanel";
import { Dot } from "@/components/common";
import { statusColor, num, timeAgo, batteryShort } from "@/lib/format";

export default function Drones() {
  const { drones, refresh } = useLiveData();
  const [params] = useSearchParams();
  const [selected, setSelected] = useState(params.get("id") || null);

  useEffect(() => {
    const q = params.get("id");
    if (q) setSelected(q);
    else if (!selected && drones.length) setSelected(drones[0].drone_id);
  }, [params, drones, selected]);

  const sel = drones.find((d) => d.drone_id === selected);

  return (
    <div className="h-full flex">
      <div className="flex-1 p-6 overflow-y-auto">
        <h1 className="font-chivo text-3xl font-black tracking-tighter uppercase mb-1">Drones</h1>
        <p className="font-mono text-xs text-[#A3A3A3] mb-5">Sélectionnez un drone pour la fiche détaillée</p>

        <div className="space-y-2">
          {drones.map((d) => {
            const sc = statusColor(d);
            return (
              <button key={d.drone_id} data-testid={`drone-row-${d.drone_id}`} onClick={() => setSelected(d.drone_id)}
                className={`w-full flex items-center justify-between bg-[#141414] border rounded-sm px-4 py-3 transition-colors ${selected === d.drone_id ? "border-[#3B82F6]" : "border-white/10 hover:border-white/25"}`}>
                <div className="flex items-center gap-3">
                  <Dot color={sc} pulse={d.status === "online"} />
                  <div className="text-left">
                    <div className="font-chivo font-bold tracking-tight">{d.drone_id}</div>
                    <div className="font-mono text-[10px] text-[#525252]">{timeAgo(d.last_seen)}</div>
                  </div>
                </div>
                <div className="flex items-center gap-4 font-mono text-xs">
                  <span style={{ color: sc }} className="uppercase text-[10px] tracking-wider">{d.status}</span>
                  <span data-testid={`drone-row-battery-${d.drone_id}`}>{batteryShort(d)}</span>
                  <span className="text-[#A3A3A3]">{num(d.alt)}m</span>
                  <span className="text-[#A3A3A3]">{d.mode}</span>
                </div>
              </button>
            );
          })}
        </div>
      </div>

      {sel && (
        <div className="w-[360px] shrink-0">
          <DroneDetailPanel droneId={sel.drone_id} base={sel} onRefresh={refresh} />
        </div>
      )}
    </div>
  );
}
